module.exports = __webpack_public_path__ + "static/media/icon_26.9ca7576d.svg";